<template>
  <div>
    <div class="pa-4 form-body">
      <div class="mb-3">
        รายละเอียดการประเมินในเอกสารฉบับนี้ ทางเจ้าหน้าที่ของสายด่วนเลิกเหล้า 1413 ผู้ประเมิน
        ได้รับทราบจากผู้ให้ ข้อมูลทางโทรศัพท์ ดังนั้นจึงจำเป็นที่ต้องได้รับการประเมินซ้ำเพื่อตรวจสอบ
        ความถูกต้องโดยบุคลากรทางสาธารณสุข อีกครั้ง
      </div>

      <div class="font-weight-bold mb-1">ความต้องการพิเศษในการเข้ารับบริการ</div>
      <div>
        <table class="form-table">
          <tr style="background: #fde0db">
            <th>ลักษณะอาการ</th>
            <th>มี</th>
            <th>ไม่มี</th>
            <th>รายละเอียด</th>
          </tr>
          <tr>
            <td class="font-weight-bold">อาการทางร่างกาย</td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.physical_symptoms === true"
                @change="
                  (value) => {
                    if (value) {
                      localData.physical_symptoms = true
                    } else {
                      localData.physical_symptoms = null
                    }
                  }
                "
              />
            </td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.physical_symptoms === false"
                @change="
                  (value) => {
                    if (value) {
                      localData.physical_symptoms = false
                    } else {
                      localData.physical_symptoms = null
                    }
                  }
                "
              />
            </td>
            <td class="form-control">
              <div v-if="readOnly">
                {{ localData.physical_symptoms_detail }}
              </div>
              <template v-else>
                <input v-model="localData.physical_symptoms_detail" type="text" />
              </template>
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">ความเสี่ยงต่อการทำร้ายตนเอง</td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.risk_self_harm === true"
                @change="
                  (value) => {
                    if (value) {
                      localData.risk_self_harm = true
                    } else {
                      localData.risk_self_harm = null
                    }
                  }
                "
              />
            </td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.risk_self_harm === false"
                @change="
                  (value) => {
                    if (value) {
                      localData.risk_self_harm = false
                    } else {
                      localData.risk_self_harm = null
                    }
                  }
                "
              />
            </td>
            <td class="form-control">
              <div v-if="readOnly">
                {{ localData.risk_self_harm_detail }}
              </div>
              <template v-else>
                <input v-model="localData.risk_self_harm_detail" type="text" />
              </template>
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">สารเสพติด</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>- เครื่องดื่มแอกอฮอลล์</td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.addict_alcohol === true"
                @change="
                  (value) => {
                    if (value) {
                      localData.addict_alcohol = true
                    } else {
                      localData.addict_alcohol = null
                    }
                  }
                "
              />
            </td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.addict_alcohol === false"
                @change="
                  (value) => {
                    if (value) {
                      localData.addict_alcohol = false
                    } else {
                      localData.addict_alcohol = null
                    }
                  }
                "
              />
            </td>
            <td class="form-control">
              <div v-if="readOnly">
                {{ localData.addict_alcohol_detail }}
              </div>
              <template v-else>
                <input v-model="localData.addict_alcohol_detail" type="text" />
              </template>
            </td>
          </tr>
          <tr>
            <td>- สารกระตุ้น</td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.addict_stimulants === true"
                @change="
                  (value) => {
                    if (value) {
                      localData.addict_stimulants = true
                    } else {
                      localData.addict_stimulants = null
                    }
                  }
                "
              />
            </td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.addict_stimulants === false"
                @change="
                  (value) => {
                    if (value) {
                      localData.addict_stimulants = false
                    } else {
                      localData.addict_stimulants = null
                    }
                  }
                "
              />
            </td>
            <td class="form-control">
              <div v-if="readOnly">
                {{ localData.addict_stimulants_detail }}
              </div>
              <template v-else>
                <input v-model="localData.addict_stimulants_detail" type="text" />
              </template>
            </td>
          </tr>
          <tr>
            <td>- กัญชา หรือกระท่อม</td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.addict_marijuana_kratom === true"
                @change="
                  (value) => {
                    if (value) {
                      localData.addict_marijuana_kratom = true
                    } else {
                      localData.addict_marijuana_kratom = null
                    }
                  }
                "
              />
            </td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.addict_marijuana_kratom === false"
                @change="
                  (value) => {
                    if (value) {
                      localData.addict_marijuana_kratom = false
                    } else {
                      localData.addict_marijuana_kratom = null
                    }
                  }
                "
              />
            </td>
            <td class="form-control">
              <div v-if="readOnly">
                {{ localData.addict_marijuana_kratom_detail }}
              </div>
              <template v-else>
                <input v-model="localData.addict_marijuana_kratom_detail" type="text" />
              </template>
            </td>
          </tr>
          <tr>
            <td>- สารอื่นๆ</td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.addict_etc === true"
                @change="
                  (value) => {
                    if (value) {
                      localData.addict_etc = true
                    } else {
                      localData.addict_etc = null
                    }
                  }
                "
              />
            </td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.addict_etc === false"
                @change="
                  (value) => {
                    if (value) {
                      localData.addict_etc = false
                    } else {
                      localData.addict_etc = null
                    }
                  }
                "
              />
            </td>
            <td class="form-control">
              <div v-if="readOnly">
                {{ localData.addict_etc_detail }}
              </div>
              <template v-else>
                <input v-model="localData.addict_etc_detail" type="text" />
              </template>
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">ความเครียด</td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.stress === true"
                @change="
                  (value) => {
                    if (value) {
                      localData.stress = true
                    } else {
                      localData.stress = null
                    }
                  }
                "
              />
            </td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.stress === false"
                @change="
                  (value) => {
                    if (value) {
                      localData.stress = false
                    } else {
                      localData.stress = null
                    }
                  }
                "
              />
            </td>
            <td class="form-control">
              <div v-if="readOnly">
                {{ localData.stress_detail }}
              </div>
              <template v-else>
                <input v-model="localData.stress_detail" type="text" />
              </template>
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">อารมณ์ซึมเศร้า</td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.depressed_mood === true"
                @change="
                  (value) => {
                    if (value) {
                      localData.depressed_mood = true
                    } else {
                      localData.depressed_mood = null
                    }
                  }
                "
              />
            </td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.depressed_mood === false"
                @change="
                  (value) => {
                    if (value) {
                      localData.depressed_mood = false
                    } else {
                      localData.depressed_mood = null
                    }
                  }
                "
              />
            </td>
            <td class="form-control">
              <div v-if="readOnly">
                {{ localData.depressed_mood_detail }}
              </div>
              <template v-else>
                <input v-model="localData.depressed_mood_detail" type="text" />
              </template>
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">ปัญหาการนอน</td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.sleeping_problem === true"
                @change="
                  (value) => {
                    if (value) {
                      localData.sleeping_problem = true
                    } else {
                      localData.sleeping_problem = null
                    }
                  }
                "
              />
            </td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.sleeping_problem === false"
                @change="
                  (value) => {
                    if (value) {
                      localData.sleeping_problem = false
                    } else {
                      localData.sleeping_problem = null
                    }
                  }
                "
              />
            </td>
            <td class="form-control">
              <div v-if="readOnly">
                {{ localData.sleeping_problem_detail }}
              </div>
              <template v-else>
                <input v-model="localData.sleeping_problem_detail" type="text" />
              </template>
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">น้ำหนักเปลี่ยนแปลง</td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.weight_change === true"
                @change="
                  (value) => {
                    if (value) {
                      localData.weight_change = true
                    } else {
                      localData.weight_change = null
                    }
                  }
                "
              />
            </td>
            <td class="form-checkbox">
              <v-checkbox
                :readonly="readOnly"
                hide-details
                color="primary"
                class="mt-0"
                :input-value="localData.weight_change === false"
                @change="
                  (value) => {
                    if (value) {
                      localData.weight_change = false
                    } else {
                      localData.weight_change = null
                    }
                  }
                "
              />
            </td>
            <td class="form-control">
              <div v-if="readOnly">
                {{ localData.weight_change_detail }}
              </div>
              <template v-else>
                <input v-model="localData.weight_change_detail" type="text" />
              </template>
            </td>
          </tr>
        </table>
      </div>
      <div class="font-weight-bold">คำอธิบายและคำแนะนำในการดูแลผู้ดื่มรายนี้</div>
      <div>
        <v-card flat style="border: 1px solid #999">
          <v-card-title class="font-weight-bold" style="background: #fde0db">
            <div style="display: flex">
              <div>ผู้ดื่มรายนี้ มีระดับความเสี่ยง ASSIST อยู่ในระดับ</div>
              <div class="form-control ml-2">
                <div v-if="readOnly">
                  {{ localData.risk_assist_level }}
                </div>
                <template v-else>
                  <input v-model="localData.risk_assist_level" type="text" />
                </template>
              </div>
            </div>
          </v-card-title>
          <div class="pa-3">
            <div v-if="readOnly" style="word-wrap: break-word">
              {{ localData.risk_assist_deatil }}
            </div>
            <template v-else>
              <v-textarea
                v-model="localData.risk_assist_deatil"
                outline
                solo
                flat
                hide-details
                auto-grow
                box
                rows="3"
              ></v-textarea>
            </template>
          </div>
        </v-card>
      </div>
      <div>
        <v-card flat style="border: 1px solid #999">
          <v-card-title class="font-weight-bold" style="background: #fde0db">
            <div style="display: flex">
              <div>แรงจูงใจของการเปลี่ยนแปลงพฤติกรรม อยู่ในระดับ</div>
              <div class="form-control ml-2">
                <div v-if="readOnly">
                  {{ localData.motivation_behavior_change_level }}
                </div>
                <template v-else>
                  <input v-model="localData.motivation_behavior_change_level" type="text" />
                </template>
              </div>
            </div>
          </v-card-title>
          <div class="pa-3">
            <div v-if="readOnly" style="word-wrap: break-word">
              {{ localData.motivation_behavior_change_detail }}
            </div>
            <template v-else>
              <v-textarea
                v-model="localData.motivation_behavior_change_detail"
                outline
                solo
                flat
                hide-details
                auto-grow
                box
                rows="3"
              ></v-textarea>
            </template>
          </div>
        </v-card>
      </div>
      <div>
        <v-card flat style="border: 1px solid #999">
          <v-card-title class="font-weight-bold" style="background: #fde0db">
            <div style="display: flex">
              <div>ความเสี่ยงที่จะเกิดอาการถอนรุนแรง</div>
              <div class="form-control ml-2">
                <div v-if="readOnly">
                  {{ localData.risk_severe_withdrawal_symptoms_level }}
                </div>
                <template v-else>
                  <input v-model="localData.risk_severe_withdrawal_symptoms_level" type="text" />
                </template>
              </div>
            </div>
          </v-card-title>
          <div class="pa-3">
            <div v-if="readOnly" style="word-wrap: break-word">
              {{ localData.risk_severe_withdrawal_symptoms_detail }}
            </div>
            <template v-else>
              <v-textarea
                v-model="localData.risk_severe_withdrawal_symptoms_detail"
                outline
                solo
                flat
                hide-details
                auto-grow
                box
                rows="3"
              ></v-textarea>
            </template>
          </div>
        </v-card>
      </div>

      <v-layout v-if="!readOnly" justify-space-between class="mt-4">
        <v-btn depressed color="grey" dark @click="$emit('onBackPage')">ย้อนกลับ</v-btn>
        <v-btn depressed color="primary" @click="handleSaveForm"> บันทึก </v-btn>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rawData: null,
      localData: {
        physical_symptoms: null,
        physical_symptoms_detail: '',
        risk_self_harm: null,
        risk_self_harm_detail: '',
        addict_alcohol: null,
        addict_alcohol_detail: '',
        addict_stimulants: null,
        addict_stimulants_detail: '',
        addict_marijuana_kratom: null,
        addict_marijuana_kratom_detail: '',
        addict_etc: null,
        addict_etc_detail: '',
        stress: null,
        stress_detail: '',
        depressed_mood: null,
        depressed_mood_detail: '',
        sleeping_problem: null,
        sleeping_problem_detail: '',
        weight_change: null,
        weight_change_detail: '',
        risk_assist_level: '',
        risk_assist_deatil: '',
        motivation_behavior_change_level: '',
        motivation_behavior_change_detail: '',
        risk_severe_withdrawal_symptoms_level: '',
        risk_severe_withdrawal_symptoms_detail: ''
      }
    }
  },
  watch: {
    data: {
      handler() {
        this.handleInit()
      },
      deep: true
    }
  },
  mounted() {
    this.handleInit()
  },
  methods: {
    handleInit() {
      this.localData.physical_symptoms = this.data.physical_symptoms
      this.localData.physical_symptoms_detail = this.data.physical_symptoms_detail
      this.localData.risk_self_harm = this.data.risk_self_harm
      this.localData.risk_self_harm_detail = this.data.risk_self_harm_detail
      this.localData.addict_alcohol = this.data.addict_alcohol
      this.localData.addict_alcohol_detail = this.data.addict_alcohol_detail
      this.localData.addict_stimulants = this.data.addict_stimulants
      this.localData.addict_stimulants_detail = this.data.addict_stimulants_detail
      this.localData.addict_marijuana_kratom = this.data.addict_marijuana_kratom
      this.localData.addict_marijuana_kratom_detail = this.data.addict_marijuana_kratom_detail
      this.localData.addict_etc = this.data.addict_etc
      this.localData.addict_etc_detail = this.data.addict_etc_detail
      this.localData.stress = this.data.stress
      this.localData.stress_detail = this.data.stress_detail
      this.localData.depressed_mood = this.data.depressed_mood
      this.localData.depressed_mood_detail = this.data.depressed_mood_detail
      this.localData.sleeping_problem = this.data.sleeping_problem
      this.localData.sleeping_problem_detail = this.data.sleeping_problem_detail
      this.localData.weight_change = this.data.weight_change
      this.localData.weight_change_detail = this.data.weight_change_detail
      this.localData.risk_assist_level = this.data.risk_assist_level
      this.localData.risk_assist_deatil = this.data.risk_assist_deatil
      this.localData.motivation_behavior_change_level = this.data.motivation_behavior_change_level
      this.localData.motivation_behavior_change_detail = this.data.motivation_behavior_change_detail
      this.localData.risk_severe_withdrawal_symptoms_level =
        this.data.risk_severe_withdrawal_symptoms_level
      this.localData.risk_severe_withdrawal_symptoms_detail =
        this.data.risk_severe_withdrawal_symptoms_detail
    },
    handleSaveForm() {
      this.$emit('onSubmitForm', this.localData)
    }
  }
}
</script>

<style lang="scss" scoped>
.form-body {
  font-size: 1rem;
  line-height: 2.1rem;

  input[type='text'] {
    height: 30px !important;
  }

  .form-table {
    th {
      text-align: center;
    }

    th,
    td {
      &.form-checkbox {
        .v-input {
          justify-content: center;
        }
      }

      &.form-control {
        input {
          margin-top: 4px;
          border-color: #666;
        }
      }
      border: 1px solid #000;
      border-collapse: collapse;
      padding: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/SelfReferral/Form/Page2.vue